import React from 'react'
import { useCallback } from "react"

export default ({ label, up, down, children, ...props }) => {
  const onUp = useCallback((e) => {
    up(e, props);
  })

  const onDown = useCallback((e) => {
    down(e, props);
  })

  return <div className="flex-1 text-center fcol">
           <div className="btn btn-primary btn-lg" onClick={ onUp }><i className="ph ph-caret-up text-xl" /></div>
           <div className="flex-1">
             <div className="text-xs">{ label }</div>
             { children }
           </div>
           <div className="btn btn-primary btn-lg" onClick={ onDown }><i className="ph ph-caret-down text-xl" /></div>
         </div>
}
